import React, { useState } from 'react';
import Dialog from '@shared/ui/molecules/Dialog';
import { useDispatch } from "react-redux";
import { closeDialog } from '@shared/store/dialog.duck';
import DialogHeader from '@shared/dialogs/DialogHeader';
import { FlatContentCard } from '@shared/ui/atoms/FlatContentCard';
import { Center, Column } from '@shared/ui/atoms/StructuralLayout';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import { MeetingRoom } from "../models/MeetingRooms";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { useTranslation } from "react-i18next";
import { deleteMeetingRoom } from '@features/meeting-rooms/MeetingRoomsService';
import { redirectTo } from '@shared/store/auth.duck';

export function DeleteMeetingRoomConfirmDialog(props: Props) {
  const {meetingRoom} = props.payload;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {t} = useTranslation();

  const close = () => dispatch(closeDialog());

  const deleteRoom = async () => {
    setLoading(true);
    try {
      await deleteMeetingRoom(meetingRoom.id);
      dispatch(redirectTo(`/manage/offices/${meetingRoom.officeId}?panel=3`));
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Dialog isOpen={true} onClose={close} showLogo={true}>
        <DialogHeader title={'delete-meeting-room-dialog.delete-meeting-room'} />
        {loading ? <Center>
          <LoadingSpinner hideBorder={true} hideText={true} />
        </Center> : <>

          <FlatContentCard style={{marginBottom: 16}}>
            <Column>
              <BodyRegular weight={600}>{meetingRoom.name}</BodyRegular>
              <BodyRegular>{t('delete-meeting-room-dialog.capacity', {capacity: meetingRoom.capacity})}</BodyRegular>
            </Column>
          </FlatContentCard>

          <PrimaryButton click={deleteRoom}
                         style={{marginBottom: 16}}
                         text={'delete-meeting-room-dialog.confirm-delete-meeting-room'}
                         fullWidth={true} />
          <OutlineButton click={close}
                         text={'delete-meeting-room-dialog.cancel'}
                         fullWidth={true} />
        </>}
      </Dialog>
    </>
  )
}

interface Props {
  payload: {
    meetingRoom: MeetingRoom,
  };
}
